import { Injectable } from '@angular/core';
import { ServiceBase } from '@app/core/service-base';
import { ThirdPartyActivity } from '../models/thirdparty-activity';
import { Observable } from 'rxjs';
import { OperationResponse } from '@app/common/models/operation-response';

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyActivityService extends ServiceBase {

  getThirdPartyActivity(itemUrl, treatAsOffline): Observable<OperationResponse<ThirdPartyActivity>> {
    return this.getObject<ThirdPartyActivity>(itemUrl, treatAsOffline);
  }

}
